/* eslint-disable @typescript-eslint/naming-convention */
export interface MapMyIndiaAuth {
  license: string;
  jwtToken: string;
}




